import React, {
  useEffect,
  useLayoutEffect,
  useReducer,
  useRef,
  useState
} from 'react';
import { connect } from 'react-redux';
import {
  AcceptButtonContainer,
  AddPhone,
  CreateContainer,
  GoBackContainer,
  PhoneSection,
  Row,
  TitleContainer,
  CreateLeadForm
} from './style';
import MainFont from '../../typography/mainFont';
import { Button, Checkbox, DropDown, Icon, Input, Textarea } from 'ui/atoms';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import theme from '../../theme';

import { CHECK_LEAD_CREATION, CREATE_LEAD_B2B } from 'redux/sagas/actions/lead';
import phonePrefixesSalesforce from '../../../utils/phonePrefixesSalesforce';
import { RegexpType, validator } from '../../../utils/validator';
import spinnerIcon from 'ui/assets/img/spinner-icon.png';
import spinnerIconWhite from 'ui/assets/img/spinner-icon-white.png';
import { SpinnerIcon } from '../../atoms/Table/style';
import CloseLeadCreation from './CloseLeadCreation';
import { RESET_CHECK_DATA } from '../../../redux/slices/lead';
import { push } from 'redux-first-history';
import { DropDownSelectPreference, existingLead } from './CreateLeadB2C'
import { initialState, reducer } from './b2bReducer';

const CreateLeadB2B = ({
  resetLeadType,
  createLeadB2B,
  errorCheckAPI,
  isLoading,
  checkLeadCreation,
  checkWasDone,
  resetCheckData,
  callbackOnclose,
  existingLeadId,
  pushUrl,
  isLoadingButton
}) => {
  const { t } = useTranslation();

  const [state, dispatch] = useReducer(reducer, initialState);
  const [errorVehicleDelivery, setErrorVehicleDelivery] = useState(false);
  const [showSecondNumber, setShowSecondNumber] = useState(false);
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorVat, setErrorVat] = useState(false);
  const [showConfirmBack, setShowConfirmBack] = useState(false);
  const [loadingCheckBeforeAdd, setLoadingCheckBeforeAdd] = useState();

  const handleSubmit = e => {
    e.preventDefault();
    const form = new URLSearchParams(
      new FormData(document.getElementById('create-lead-form'))
    )?.toString();
    createLeadB2B({
      companyLegalName: state.companyName,
      email: state.email,
      form,
      state
    });
  };

  useEffect(() => {
    return () => {
      resetCheckData();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetCheckData]);

  useEffect(() => {
    if (
      state.vehicleDelivery &&
      !validator(RegexpType.VEHICHLEDELIVERY, state.vehicleDelivery)
    ) {
      setErrorVehicleDelivery(true);
    } else {
      setErrorVehicleDelivery(false);
    }
  }, [state.vehicleDelivery]);

  useEffect(() => {
    if (state.email) {
      if (!validator(RegexpType.EMAIL, state.email)) {
        setErrorEmail(true);
      } else {
        setErrorEmail(false);
      }
    }
  }, [state.email]);

  useEffect(() => {
    if (state.vatNumber) {
      if (state.vatNumber.length > 14) {
        setErrorVat(true);
      } else {
        setErrorVat(false);
      }
    }
  }, [state.vatNumber]);

  useEffect(() => {
    if (
      state.companyName &&
      state.email &&
      document.activeElement.id !== 'company_legal_name_id' &&
      document.activeElement.id !== 'email' &&
      !isLoading &&
      !errorCheckAPI &&
      !checkWasDone
    ) {
      checkLeadCreation({
        companyName: state.companyName,
        email: state.email
      });
    }
  }, [
    checkLeadCreation,
    state,
    state.companyName,
    state.email,
    isLoading,
    errorCheckAPI,
    checkWasDone
  ]);

  useEffect(() => {
    if (errorCheckAPI) {
      const compLegalNameField = document.getElementById(
        'anchor-comp-legal-name'
      );
      if (compLegalNameField) {
        compLegalNameField.scrollIntoView();
      }
    }
  }, [errorCheckAPI]);

  const isDisabled = () =>
    !state.privacyChecked ||
    !state.companyName ||
    !state.firstName ||
    !state.lastName ||
    !state.email ||
    !state.prefix ||
    !state.phoneNumber ||
    !state.street ||
    !state.zip ||
    errorEmail ||
    errorVehicleDelivery ||
    errorCheckAPI ||
    !state.productInterest ||
    (state.productInterest || []).length < 1 ||
    errorVat;

  const loadCorrectIcon = () => {
    if (
      state.companyName.length !== 0 &&
      state.email.length !== 0 &&
      !errorEmail
    ) {
      if (isLoading) {
        return <SpinnerIcon icon={spinnerIcon} />;
      } else {
        if (errorCheckAPI) {
          return (
            <Icon
              type="icon-exclamation"
              color={theme().colors.statusRed}
              size={24}
            />
          );
        } else if (!errorCheckAPI && checkWasDone) {
          return (
            <Icon
              type="icon-icon-success"
              color={theme().colors.aquamarine}
              size={24}
            />
          );
        }
      }
    }
    return <></>;
  };

  const addRef = useRef();
  const remRef = useRef();

  const [addWidth, setAddWidth] = useState(0);
  const [remWidth, setRemWidth] = useState(0);

  useLayoutEffect(() => {
    if (addRef.current !== null && addRef.current) {
      setAddWidth(addRef.current.offsetWidth);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t('add_new_lead')]);

  useLayoutEffect(() => {
    if (showSecondNumber && remWidth === 0) {
      if (remRef.current !== null && remRef.current) {
        setRemWidth(remRef.current.offsetWidth);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t('add_new_lead'), showSecondNumber]);

  useEffect(()=> {
    setLoadingCheckBeforeAdd(isLoadingButton);
  }, [isLoadingButton])

  const loadB2BForm = () => {
    return (
      <>
        {' '}
        <TitleContainer>
          <GoBackContainer>
            <Icon
              type="icon-back"
              size="20"
              color={theme().colors.aquamarine}
              onClick={() => setShowConfirmBack(true)}
            />
          </GoBackContainer>
          <MainFont type="createAccountHeaders">
            {t('add_new_lead')} {t('business')}
          </MainFont>
        </TitleContainer>
        {/*<iframe id="invisible" name="invisible" style={{ display: 'none' }} />*/}
        <CreateLeadForm id="create-lead-form" target="invisible">
          <MainFont type="description">
            {t('customer_info')} & {t('vehicle_info')}
          </MainFont>
          <div id="anchor-comp-legal-name" />
          <Input
            id="company_legal_name_id"
            name="company_legal_name_id"
            type="text"
            placeholder={`${t('company_legal_name')}*`}
            variant="editaccountdata"
            status={errorCheckAPI ? 'invalid' : ''}
            value={state.companyName}
            onChange={e => {
              if (errorCheckAPI) {
                resetCheckData();
              }
              dispatch({
                type: 'set_company_name',
                payload: e.currentTarget.value
              });
            }}
            icon={loadCorrectIcon()}
          />
          <Input
            id="email"
            name="email"
            type="email"
            placeholder={`${t('email_placeholder')}*`}
            variant="editaccountdata"
            value={state.email}
            status={errorCheckAPI || errorEmail ? 'invalid' : ''}
            onChange={e => {
              if (errorCheckAPI) {
                resetCheckData();
              }
              dispatch({
                type: 'set_email',
                payload: e.currentTarget.value
              });
            }}
            icon={loadCorrectIcon()}
          />
          {existingLead(errorCheckAPI, existingLeadId, pushUrl, t)}
          {errorEmail && (
            <div>
              <MainFont type="errorLabel">{t('email_error')}</MainFont>
            </div>
          )}
          <Row split={'1/2'}>
            <Input
              id="first_name"
              name="first_name"
              type="text"
              placeholder={`${t('contact_name')}*`}
              //status={state.name === '' && 'empty'}
              variant={'editaccountdata'}
              value={state.firstName}
              onChange={e =>
                dispatch({
                  type: 'set_name',
                  payload: e.currentTarget.value
                })
              }
            />
            <Input
              id="last_name"
              name="last_name"
              type="text"
              placeholder={`${t('contact_surname')}*`}
              status={!state.last_name ? 'empty' : ''}
              variant={'editaccountdata'}
              value={state.lastName}
              onChange={e =>
                dispatch({
                  type: 'set_last_name',
                  payload: e.currentTarget.value
                })
              }
            />
          </Row>
          <PhoneSection showSecondNumber={showSecondNumber} addWidth={addWidth}>
            <DropDown
              type="tel"
              placeholder={`${t('prefix')}*`}
              options={phonePrefixesSalesforce}
              onChange={selection => {
                dispatch({
                  type: 'set_phone_number_prefix',
                  payload: selection.value
                });
              }}
              variant="editaccountdata"
              detachedOptions
              noMinWidth
            />
            <Input
              type="tel"
              placeholder={`${t('phone_number')}*`}
              status={state.phoneNumber === '' && 'empty'}
              variant="editaccountdata"
              value={state.phoneNumber}
              onChange={e =>
                dispatch({
                  type: 'set_phone_number_part',
                  payload: e.currentTarget.value
                })
              }
              id="phone"
              name="phone"
              phoneSection
            />
            {!showSecondNumber && (
              <AddPhone
                className="addField"
                onClick={() => setShowSecondNumber(true)}
              >
                <Icon
                  type="icon-add"
                  color={theme().colors.aquamarine}
                  size={16}
                />
                <div ref={addRef}>
                  <MainFont type="addPhoneNumber">{t('add')}</MainFont>
                </div>
              </AddPhone>
            )}
          </PhoneSection>
          {showSecondNumber && (
            <PhoneSection remWidth={remWidth}>
              <DropDown
                type="tel"
                options={phonePrefixesSalesforce}
                onChange={selection => {
                  dispatch({
                    type: 'set_phone_number_prefix2',
                    payload: selection.value
                  });
                }}
                variant="editaccountdata"
                detachedOptions
                noMinWidth
                placeholder={`${t('prefix')}`}
              />
              <Input
                type="tel"
                placeholder={`${t('phone_number')}`}
                status={state.phoneNumber2 === '' && 'empty'}
                variant="editaccountdata"
                value={state.phoneNumber2}
                onChange={e =>
                  dispatch({
                    type: 'set_phone_number_part_2',
                    payload: e.currentTarget.value
                  })
                }
                id="mobile"
                name="mobile"
                phoneSection
              />

              <AddPhone
                onClick={() => setShowSecondNumber(false)}
                className="remField"
                remWidth={remWidth}
              >
                <Icon
                  type="icon-bin"
                  color={theme().colors.aquamarine}
                  size={16}
                />
                <div ref={remRef}>
                  <MainFont type="addPhoneNumber">{t('delete')}</MainFont>
                </div>
              </AddPhone>
            </PhoneSection>
          )}
          <Input
            id="vat_id"
            name="vat_id"
            type="text"
            placeholder={`${t('VAT')}`}
            variant="editaccountdata"
            status={errorVat ? 'invalid' : ''}
            value={state.vatNumber}
            onChange={e =>
              dispatch({
                type: 'set_vat_number',
                payload: e.currentTarget.value
              })
            }
          />
          {errorVat && (
            <div>
              <MainFont type="errorLabel">{t('vat_error')}</MainFont>
            </div>
          )}
          <Row split="2/3">
            <Input
              id="street"
              name="street"
              type="text"
              placeholder={`${t('address')}*`}
              variant="editaccountdata"
              rows={1}
              value={state.street}
              onChange={e =>
                dispatch({
                  type: 'set_street',
                  payload: e.currentTarget.value
                })
              }
            />
            <Input
              id="zip"
              name="zip"
              type="text"
              placeholder={`${t('zip')}*`}
              variant="editaccountdata"
              //status={state.name === '' && 'empty'}
              value={state.zip}
              onChange={e =>
                dispatch({
                  type: 'set_zip',
                  payload: e.currentTarget.value
                })
              }
            />
          </Row>
          {DropDownSelectPreference(dispatch, t)}
          <Input
            id="palace_stairs_id"
            name="palace_stairs_id"
            type="text"
            maxlength={80}
            placeholder={`${t('building_or_place_called')}`}
            variant="editaccountdata"
            value={state.building}
            onChange={e =>
              dispatch({
                type: 'set_building',
                payload: e.currentTarget.value
              })
            }
          />
          <Input
            id="vehicle_delivery_id"
            name="vehicle_delivery_id"
            type="text"
            placeholder={`${t('vehicle_delivery_date')}`}
            variant="editaccountdata"
            value={state.vehicleDelivery}
            onChange={e =>
              dispatch({
                type: 'set_vehicle_delivery',
                payload: e.currentTarget.value
              })
            }
            status={errorVehicleDelivery ? 'invalid' : ''}
          />
          <Textarea
            id="notes_field"
            name="notes_field"
            placeholder={t('notes')}
            variant="form"
            value={state.notes}
            onChange={e =>
              dispatch({
                type: 'set_notes',
                payload: e.currentTarget.value?.substring(0, 255)
              })
            }
            maxLength={255}
          />
          {state.notes.length >= 255 && (
            <div>
              <MainFont>{t('invalid_note_length')}</MainFont>
            </div>
          )}
          <Row
            onClick={() => {
              dispatch({
                type: 'set_checkbox',
                payload: !state.privacyChecked
              });
            }}
            clickable
          >
            <Checkbox checked={state.privacyChecked} />
            <MainFont>{t('privacy_policy_label')}</MainFont>
          </Row>
          {loadingCheckBeforeAdd ? (
            <AcceptButtonContainer
              id="button-container"
              onClick={e => e.preventDefault()}
            >
              <Button variant="accept-button" noPadding>
                <SpinnerIcon icon={spinnerIconWhite} marginRight={11} />
                <MainFont type="addAccountLabels">{t('loading')}</MainFont>
              </Button>
            </AcceptButtonContainer>
          ) : (
            <AcceptButtonContainer id="button-container">
              <Button
                variant="accept-button"
                onClick={e => {
                  handleSubmit(e);
                }}
                disabled={isDisabled()}
              >
                <MainFont type="addAccountLabels">{t('create')}</MainFont>
              </Button>
            </AcceptButtonContainer>
          )}
        </CreateLeadForm>
      </>
    );
  };

  return (
    <CreateContainer>
      {showConfirmBack ? (
        <CloseLeadCreation
          leadClose={resetLeadType}
          reloadCreate={() => setShowConfirmBack(false)}
        />
      ) : (
        loadB2BForm()
      )}
    </CreateContainer>
  );
};

CreateLeadB2B.propTypes = {
  resetLeadType: PropTypes.func,
  createLeadB2B: PropTypes.func,
  isLoading: PropTypes.bool,
  errorCheckAPI: PropTypes.string,
  checkLeadCreation: PropTypes.func,
  resetCheckData: PropTypes.func,
  callbackOnclose: PropTypes.func,
  checkWasDone: PropTypes.bool,
  pushUrl: PropTypes.func,
  existingLeadId: PropTypes.string,

};

export default connect(
  state => ({
    companyCode: state?.authentication?.accountInfo?.companyCode,
    cognitoId: state?.authentication?.accountInfo?.cognitoId,
    isLoading: state?.lead?.isLoadingCheck,
    checkWasDone: state?.lead?.checkWasDone,
    errorCheckAPI: state?.lead?.errorCheckAPI,
    existingLeadId: state?.lead?.existingLeadId,
    isLoadingButton: state?.lead?.isLoadingButton
  }),
  dispatch => ({
    createLeadB2B: payload =>
      dispatch({ type: CREATE_LEAD_B2B._REQUEST, payload }),
    checkLeadCreation: payload =>
      dispatch({ type: CHECK_LEAD_CREATION._REQUEST, payload }),
    resetCheckData: () => dispatch(RESET_CHECK_DATA()),
    pushUrl: url => dispatch(push(url))
  })
)(CreateLeadB2B);
